import React from 'react';
import { animated, useSpring } from '@react-spring/web';
import { useDrag } from 'react-use-gesture';
const SlideUpPanelContainer = ({ children, closeable = false, onClose }) => {
    let style;
    let handle;
    if (closeable) {
        const [{ y }, set] = useSpring(() => ({ y: 0 }));
        style = { transform: y.interpolate(y => `translate3d(0, ${y}px, 0)`) };
        const bind = useDrag(({ cancel, distance, down, movement: [, my] }) => {
            if (distance > window.innerHeight / 3) {
                cancel?.();
                onClose();
            }
            set({ y: (down && my > 0) ? my : 0 });
        });
        handle = React.createElement("div", { className: "c-slide-up-panel__handle", ...bind() });
    }
    return (React.createElement(animated.div, { className: "c-slide-up-panel__container", style: style },
        handle,
        children));
};
export { SlideUpPanelContainer, };
//# sourceMappingURL=slide-up-panel-container.js.map